import EmptyMessage from 'components/gruenland/atoms/empty-message/EmptyMessage';
import useCloseFlyouts from 'helpers/hooks/useCloseFlyouts';
import { useFormat } from 'helpers/hooks/useFormat';
import { CartSlideoutProps } from './type';
import CartItem from '../cart/components/cart-item';
import CartPaymentSection from '../cart-summary/CartPaymentSection';
import CheckoutButton from '../cart-summary/CheckoutButton';

const CartSlideout: React.FC<CartSlideoutProps> = ({
  cart,
  isEmpty,
  onApplyDiscountCode,
  onRemoveDiscountCode,
  onRemoveItem,
  onUpdateItem,
}) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const closeFlyouts = useCloseFlyouts();

  return (
    <>
      {isEmpty ? (
        <EmptyMessage>
          {formatMessage({ id: 'cart.empty', defaultMessage: 'Non hai nessun articolo nel carrello.' })}
        </EmptyMessage>
      ) : (
        <>
          <div className="h-[65vh] grow divide-y divide-neutral-400 overflow-auto px-3 md:px-[22px]">
            {cart?.lineItems?.map((lineItem) => (
              <CartItem
                key={lineItem.lineItemId}
                item={lineItem}
                onRemoveItem={() => onRemoveItem(lineItem)}
                onUpdateItem={(quantity) => onUpdateItem(lineItem.lineItemId as string, quantity)}
              />
            ))}
          </div>
          <div className="p-5">
            <CartPaymentSection
              discounts={cart?.discountCodes ?? []}
              onApplyDiscountCode={onApplyDiscountCode}
              onRemoveDiscountCode={onRemoveDiscountCode}
              isEmpty={isEmpty}
              button={
                <CheckoutButton
                  className="mt-5"
                  disabled={isEmpty}
                  text={formatMessage({ id: 'cart.go', defaultMessage: 'Vai al carrello' })}
                  link="/cart"
                  onClick={closeFlyouts}
                />
              }
            />
          </div>
        </>
      )}
    </>
  );
};

export default CartSlideout;
